import { render, staticRenderFns } from "./cookies-modal.vue?vue&type=template&id=3e46b5ec&"
import script from "./cookies-modal.vue?vue&type=script&lang=js&"
export * from "./cookies-modal.vue?vue&type=script&lang=js&"
import style0 from "./cookies-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e46b5ec')) {
      api.createRecord('3e46b5ec', component.options)
    } else {
      api.reload('3e46b5ec', component.options)
    }
    module.hot.accept("./cookies-modal.vue?vue&type=template&id=3e46b5ec&", function () {
      api.rerender('3e46b5ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/common/cookies-modal.vue"
export default component.exports